__webpack_require__.p = "/dskotah/";